(function () {
  function fitPreviewText(preview) {
    window.requestAnimationFrame(function () {
      Array.prototype.forEach.call(preview.querySelectorAll('[data-personalised-preview-text]'), function (node) {
        var art = node.closest('[data-personalised-art]');
        if (!art) return;
        node.style.removeProperty('font-size');
        var naturalSize = parseFloat(window.getComputedStyle(node).fontSize);
        var availableWidth = art.clientWidth * 0.94;
        var measuredWidth = node.scrollWidth;
        if (!naturalSize || !availableWidth || !measuredWidth) return;
        if (measuredWidth > availableWidth) {
          var fittedSize = Math.max(8, naturalSize * (availableWidth / measuredWidth) * 0.97);
          node.style.fontSize = fittedSize.toFixed(2) + 'px';
        }
      });
    });
  }

  function textOfOption(option) {
    return String(option.value || option.textContent || '').replace(/\s+—\s+Most popular/i, '').trim();
  }

  function enhanceSelect(select, kind, orderedValues) {
    if (!select || select.dataset.tscPillsReady === 'true') return null;
    var options = Array.prototype.slice.call(select.options);
    if (orderedValues && orderedValues.length) {
      options.sort(function (a, b) {
        return orderedValues.indexOf(a.value) - orderedValues.indexOf(b.value);
      });
    }
    var pills = document.createElement('div');
    pills.className = 'tsc-option-pills tsc-option-pills--' + kind;
    pills.setAttribute('role', 'radiogroup');
    var colours = { White: '#ffffff', Red: '#cf1f2b', Blue: '#2582ba', Black: '#080808' };

    function sync() {
      Array.prototype.forEach.call(pills.querySelectorAll('.tsc-option-pill'), function (button) {
        var selected = button.dataset.value === select.value;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-checked', String(selected));
      });
    }

    options.forEach(function (option) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'tsc-option-pill';
      button.dataset.value = option.value;
      button.setAttribute('role', 'radio');
      if (kind === 'thread') {
        var dot = document.createElement('span');
        dot.className = 'tsc-option-pill__dot';
        dot.style.setProperty('--pill-colour', colours[option.value] || '#fff');
        dot.setAttribute('aria-hidden', 'true');
        button.appendChild(dot);
      }
      var label = document.createElement('span');
      label.textContent = textOfOption(option);
      button.appendChild(label);
      button.addEventListener('click', function () {
        if (select.value !== option.value) {
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        sync();
      });
      pills.appendChild(button);
    });

    select.classList.add('tsc-native-select--enhanced');
    select.insertAdjacentElement('afterend', pills);
    select.addEventListener('change', sync);
    select.dataset.tscPillsReady = 'true';
    sync();
    return pills;
  }

  function initialise(root) {
    if (!root || root.dataset.productHandle !== 'personalised-callsign-patch') return;
    if (root.dataset.tscCallsignUnified === 'true') return;

    var controls = root.querySelector('[data-personalised-controls]');
    var preview = root.querySelector('[data-personalised-preview]');
    if (!controls || !preview) return;

    var card = document.createElement('section');
    card.className = 'tsc-callsign-unified';
    card.setAttribute('aria-label', 'Design your personalised callsign patch');

    var notice = document.createElement('div');
    notice.className = 'tsc-callsign-unified__notice';
    notice.innerHTML = '<span class="tsc-callsign-unified__notice-icon" aria-hidden="true">🧵</span><div><strong>Made to order</strong><span>Dispatches in 5–7 business days. Delivery time is additional.</span></div>';

    var grid = document.createElement('div');
    grid.className = 'tsc-callsign-unified__grid';

    var controlsColumn = document.createElement('div');
    controlsColumn.className = 'tsc-callsign-unified__controls';

    var previewCard = document.createElement('div');
    previewCard.className = 'tsc-callsign-unified__preview-card';

    var previewTitle = document.createElement('p');
    previewTitle.className = 'tsc-callsign-unified__preview-title';
    previewTitle.textContent = 'Your patch preview';

    var insertionPoint = controls.parentNode;
    insertionPoint.insertBefore(card, controls);
    controlsColumn.appendChild(controls);
    previewCard.appendChild(previewTitle);
    previewCard.appendChild(preview);
    grid.appendChild(controlsColumn);
    grid.appendChild(previewCard);
    card.appendChild(notice);
    card.appendChild(grid);

    var mediaGroup = root.querySelector('[data-product-single-media-group]');
    if (mediaGroup) mediaGroup.classList.add('tsc-callsign-media-hidden');

    var textInput = controls.querySelector('[data-personalised-text]');
    var textField = textInput ? textInput.closest('.personalised-controls__field') : null;
    if (textInput && textField) {
      var textLabel = textField.querySelector('label');
      if (textLabel) textLabel.textContent = 'CALLSIGN TEXT';
      textInput.placeholder = 'e.g. TOP GUN 21';
      textInput.maxLength = 16;

      var inputRow = document.createElement('div');
      inputRow.className = 'tsc-callsign-input-row';
      textInput.parentNode.insertBefore(inputRow, textInput);
      inputRow.appendChild(textInput);

      var counter = document.createElement('span');
      counter.className = 'tsc-callsign-counter';
      counter.setAttribute('aria-live', 'polite');
      inputRow.appendChild(counter);

      var syncCounter = function () {
        counter.textContent = String(textInput.value.length) + ' / 16';
      };
      textInput.addEventListener('input', function () {
        window.requestAnimationFrame(syncCounter);
      });
      syncCounter();
    }

    var entries = controls.querySelector('.personalised-controls__entries--prominent');
    var callsignHelp = controls.querySelector('.personalised-controls__help--callsign');
    if (callsignHelp) callsignHelp.textContent = 'One or two short words. Spaces count toward the 16-character limit.';

    var sizeSelect = controls.querySelector('[data-personalised-size]');
    var packSelect = controls.querySelector('[data-personalised-pack]');
    var threadSelect = controls.querySelector('[data-personalised-thread]');
    var sizeField = sizeSelect ? sizeSelect.closest('.personalised-controls__field') : null;
    var packField = packSelect ? packSelect.closest('.personalised-controls__field') : null;
    var threadField = threadSelect ? threadSelect.closest('.personalised-controls__field') : null;
    var fabricField = controls.querySelector('.personalised-controls__fixed-option');
    fabricField = fabricField ? fabricField.closest('.personalised-controls__field') : null;
    var oldRow = threadField ? threadField.parentElement : null;

    if (sizeField) sizeField.classList.add('tsc-callsign-size-field');
    if (fabricField) fabricField.classList.add('tsc-callsign-fabric-field');

    if (entries && threadField) entries.insertAdjacentElement('afterend', threadField);
    if (threadField && callsignHelp) threadField.insertAdjacentElement('afterend', callsignHelp);
    if (callsignHelp && packField) callsignHelp.insertAdjacentElement('afterend', packField);
    if (oldRow && oldRow.children.length === 0) oldRow.classList.add('tsc-callsign-empty-row');

    var threadLabel = threadField ? threadField.querySelector('label') : null;
    if (threadLabel) threadLabel.textContent = 'THREAD COLOUR';
    var packLabel = packField ? packField.querySelector('label') : null;
    if (packLabel) packLabel.textContent = 'PACK QUANTITY';

    enhanceSelect(threadSelect, 'thread', ['White', 'Red', 'Blue', 'Black']);
    enhanceSelect(packSelect, 'pack');

    var blackThreadNote = threadField ? threadField.querySelector('.personalised-controls__help') : null;
    if (blackThreadNote) blackThreadNote.hidden = true;

    var status = preview.querySelector('[data-personalised-preview-status]');
    if (status) status.textContent = 'Preview auto-fits all 16 characters. No text is cut off.';

    var refitPreview = function () { fitPreviewText(preview); };
    if (textInput) textInput.addEventListener('input', refitPreview);
    window.addEventListener('resize', refitPreview);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(refitPreview);
    refitPreview();

    root.classList.add('tsc-callsign-unified-ready');
    root.dataset.tscCallsignUnified = 'true';
  }

  function initialiseAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-custom-patch-root]'), initialise);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialiseAll(document); });
  } else {
    initialiseAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initialiseAll(event.target); });
})();
